import { cn } from '@/lib/utils'

import type { ProductCardSkeletonProps } from '../../types'

const CONTAINER_CLASSES = 'group relative bg-white p-0 justify-between items-center gap-1 border-2 border-white hover:border-text-color transition-colors duration-300 grid grid-rows-2 w-full overflow-hidden h-[340px] xl:h-[430px]'

const CONTENT_CLASSES = 'row-span-1 px-2 grid grid-rows-4 gap-1 h-[145px] xl:h-[195px] w-full min-w-0'

/**
 * ProductCardSkeleton - Loading placeholder matching ProductCard grid layout
 *
 * Matches the 2-row grid with compact dimensions from CardItem.tsx.
 */
export function ProductCardSkeleton({ className }: ProductCardSkeletonProps) {
  return (
    <div className={cn(CONTAINER_CLASSES, 'animate-pulse', className)}>
      {/* Image Skeleton */}
      <div className="h-[150px] xl:h-[200px] bg-gray-200 rounded" />

      {/* Content Skeleton (4-row grid matching content layout) */}
      <div className={CONTENT_CLASSES}>
        {/* Name Skeleton */}
        <div className="flex flex-col gap-1 items-center">
          <div className="h-4 bg-gray-200 rounded w-full" />
          <div className="h-4 bg-gray-200 rounded w-2/3" />
        </div>

        {/* Reward Points Skeleton */}
        <div className="flex justify-center items-center min-h-[25px]">
          <div className="h-4 bg-gray-200 rounded w-24" />
        </div>

        {/* Price Skeleton */}
        <div className="flex justify-center items-end">
          <div className="h-6 bg-gray-200 rounded w-24 mx-auto" />
        </div>

        {/* Button Skeleton */}
        <div className="flex justify-center">
          <div className="h-[35px] xl:h-[45px] bg-gray-200 rounded w-4/5 xl:w-full" />
        </div>
      </div>
    </div>
  )
}
